import React from "react";
import ModalContainer from "./ModalContainer";
import useResponsive from "../../hooks/useResponsive";
import { Logo } from "../../assets/svg/icons/";

const Header = () => {
  const [modalOpen, setModalOpen] = React.useState(false);
  const { Default, Mobile } = useResponsive();

  const handleOpenModal = () => setModalOpen(true);
  const handleCloseModal = () => setModalOpen(false);

  return (
    <>
      <header className="header">
        <a href="/vem-bestammer">
          <Logo aria-hidden="true" />
        </a>
        <Default>
          <a href={process.env.REACT_APP_SV_URL} className="home_link">
            <span>Tillbaka till Studieförbundet Vuxenskolan</span>
            <div className="home_icon"></div>
          </a>
        </Default>
        <Mobile>
          <a
            href={process.env.REACT_APP_SV_URL}
            className="home_link"
            aria-label="Tillbaka till Studieförbundet Vuxenskolan"
          >
            <div className="home_icon"></div>
          </a>
        </Mobile>
        <button onClick={handleOpenModal} className="header-help_button">
          <span>Hjälp</span>
          <div className="help_icon"></div>
        </button>
      </header>
      <ModalContainer open={modalOpen} handleClose={handleCloseModal} />
    </>
  );
};

export default Header;
